import { render, staticRenderFns } from "./RoeIdLoginButton.vue?vue&type=template&id=153ee224&scoped=true"
import script from "./RoeIdLoginButton.vue?vue&type=script&lang=js"
export * from "./RoeIdLoginButton.vue?vue&type=script&lang=js"
import style0 from "./RoeIdLoginButton.vue?vue&type=style&index=0&id=153ee224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153ee224",
  null
  
)

export default component.exports